/**
 *
 * Asynchronously loads the component for Payouts
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
